import { InfoModal } from 'fmc-digital-common';
import { InfoJson } from '@components/TaxDocumentWidget/InfoJson';
import { logUserEvent } from '@analytics/amplifyLogging';
import { AmplifyLogs, CodingConstants } from '@constants';
import { Wrapper } from '@components/AlertModal/AlertModal.styled';
import React from 'react';
import { NativeBaseProvider } from 'native-base';
const { turboTaxPopUp } = CodingConstants;
export const TurboTaxModal = ({ isOpen, onClose, id = turboTaxPopUp }: any) => {
    return !isOpen ? null : (
        <Wrapper role="modal">
            <InfoModal
                data={InfoJson}
                isOpen={isOpen}
                onClose={() => {
                    if (id === turboTaxPopUp) {
                        window.localStorage.setItem('TurboTaxStatus', 'shown');
                        logUserEvent(AmplifyLogs.turboTaxPopupClosedViaLogin);
                    } else {
                        window.localStorage.setItem('TurboTaxStatusOnWidget', 'shown');
                        logUserEvent(AmplifyLogs.turboTaxPopupClosed);
                    }
                    onClose();
                }}
                handleTaxBtnClick={(url: string) => {
                    if (id === turboTaxPopUp) {
                        logUserEvent(AmplifyLogs.turboTaxPopupButtonClickedViaLogin);
                    } else {
                        logUserEvent(AmplifyLogs.turboTaxPopupButtonClicked);
                    }
                    window.open(url);
                }}
            />
        </Wrapper>
    );
};
